// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1rLhw","colMin":"styles_colMin__2Ukht","colCheckbox":"styles_colCheckbox__25w-s"};